// Utility layer (TS-2.5.04) - pure, no side effects. Turns a SaveResult's issues into
// WarningsBanner items, mirroring projects/lib/saveBanners.ts's issueBannerItems for this
// feature's several SaveResult<T> mutations (reference values, layout, branding, field maps).
import type { ValidationIssue } from "../../../api/generated/contracts";
import type { WarningsBannerItem } from "../../../components/WarningsBanner";

export function issueBannerItems(issues: readonly ValidationIssue[]): WarningsBannerItem[] {
  return issues.map((issue, index) => ({
    key: `issue-${issue.code}-${issue.field ?? index}`,
    tone: "info",
    message: issue.message,
  }));
}
